// @flow
import styled from "styled-components";
import { sectionHeading, media } from "@nested/brand";
import { Link } from "./Link";
import { PostCard } from "./PostCard";

const H4 = styled.h4`
  ${sectionHeading}
`;

const CategoryLink = styled(Link)`
  text-decoration: underline;
  font-weight: 500;
  float: right;
`;

const Wrapper = styled.div`
  margin-top: 50px;
`;

const Post = styled.div`
  ${media.tablet`
    vertical-align: top;
    width: calc(50% - 10px);
    display: inline-block;
    :nth-child(even) {
      margin-left: 20px;
    }
  `}
`;

type Props = {
  posts: { post: PrismicPost }[],
  category: PrismicCategory,
};

const RelatedPosts = ({ posts, category }: Props) => (
  <Wrapper>
    <CategoryLink to={`/blog/categories/${category.uid}`}>
      View similar stories
    </CategoryLink>
    <H4 data-test="category-preview-name" left>
      {category.data.name}
    </H4>
    <Wrapper>
      {posts.map(({ post }) => (
        <Post>
          <PostCard hideCategory post={post} key={post.uid} />
        </Post>
      ))}
    </Wrapper>
  </Wrapper>
);

export { RelatedPosts };
